/* eslint-disable-file prettier/prettier */
import React, {Suspense} from 'react'
import {Row, Col, FullScreenLoader, InlineLoader} from '@modifi/ui'
import {getComponentDisplayName} from '@modifi/utilities'

function withSuspense<T extends React.ComponentType = React.ComponentType<any>>(fullScreen = true) {
  return (WrappedComponent: T): T => {
    let Loader = FullScreenLoader
    if (!fullScreen) {
      Loader = () => (
        <Row justifyContent="center" mt={50}>
          <Col auto>
            <InlineLoader />
          </Col>
        </Row>
      )
    }

    const ScopedComponent = (props: any) => (
      <Suspense fallback={<Loader />}>
        <WrappedComponent {...props} />
      </Suspense>
    )
    ScopedComponent.displayName = `withSuspense(${getComponentDisplayName(WrappedComponent)})`
    return ScopedComponent as T
  }
}

export default withSuspense
